import Vue from 'vue';

Vue.component('monitor-index', () =>
    import(/* webpackChunkName: 'monitor-index' */ './monitor-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/monitor/index.js